import React, { useMemo } from 'react';
import { PapiDeviation, PapiUser } from '@wix/da-papi-types';
import { useTranslation } from 'react-i18next';
import TierManageContentButton from '@wix/da-shared-react/pkg/Tier/TierManageContentButton';
import UnderlinedTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import { SubscriptionsTierContentType } from '../../../../types/subscriptionsSection';
import TierContentEmptyState from './EmptyState';
import TierContentFeed from './TierContentFeed';
import TiersDropdown from './TiersDropdown';

import s from './TierContent.scss';

export interface Props {
  isOwner: boolean;
  profileOwner: PapiUser;
  moduleId: number;
  streamId: string;
  tier?: PapiDeviation;
  isEmpty?: boolean;
  selectedTierContentType: SubscriptionsTierContentType;
  setSelectedTierContentType: (type: SubscriptionsTierContentType) => void;
}

const TierContent: React.FC<Props> = ({
  isEmpty,
  isOwner,
  profileOwner,
  tier,
  streamId,
  selectedTierContentType,
  setSelectedTierContentType,
}) => {
  const { t } = useTranslation();

  const tabs = useMemo(
    () => [
      {
        index: SubscriptionsTierContentType.DEVIATIONS,
        label: t('widgets.tierContent.tabs.deviations'),
      },
      {
        index: SubscriptionsTierContentType.POSTS,
        label: t('widgets.tierContent.tabs.posts'),
      },
    ],
    [t]
  );

  if (!tier) {
    return null;
  }
  return (
    <div className={s['root']}>
      <div className={s['toolbar']}>
        <TiersDropdown className={s['title']} />
        <UnderlinedTabs
          size="big"
          className={s['tabs']}
          items={tabs}
          activeIndex={selectedTierContentType}
          onChange={tab =>
            setSelectedTierContentType(tab as SubscriptionsTierContentType)
          }
        />

        <div className={s['buttons']}>
          {isOwner && (
            <>
              <TierManageContentButton
                type={'deviations'}
                tierDeviation={tier}
                profileOwner={profileOwner}
              />
              <TierManageContentButton
                type={'posts'}
                tierDeviation={tier}
                profileOwner={profileOwner}
              />
            </>
          )}
        </div>
      </div>
      <div className={s['content']}>
        {isEmpty && <TierContentEmptyState />}
        {!isEmpty && (
          <TierContentFeed
            streamId={streamId}
            tierContentType={selectedTierContentType}
          />
        )}
      </div>
    </div>
  );
};
TierContent.displayName = 'TierContent';

export default TierContent;
